angular
  .module("app")
  .controller("manageMemberPackageController", manageMemberPackageController);

manageMemberPackageController.$inject = [
  "$scope",
  "$rootScope",
  "$uibModalInstance",
  "memberPackageId",
  "MemberPackagesApi",
  "handleError",
  "$timeout",
  "confirmDialog",
  "thisSiteSettings",
  "UploadsApi",
  "CategoryTypesApi",
  "CategoriesApi",
];

function manageMemberPackageController(
  $scope,
  $rootScope,
  $uibModalInstance,
  memberPackageId,
  MemberPackagesApi,
  handleError,
  $timeout,
  confirmDialog,
  thisSiteSettings,
  UploadsApi,
  CategoryTypesApi,
  CategoriesApi,
) {
  // properties
  $scope.isLoading = false;
  $scope.isLoadingMessage = "Loading...";
  $scope.memberPackageId = memberPackageId;
  $scope.createNewMemberPackage = !memberPackageId;
  $scope.thisUser = $rootScope.thisUser;
  $scope.formErrors = {};
  $scope.days = 365;
  $scope.categoryTypes = []; // each one with "categories" and "selectedCategoryId" array
  $scope.memberPackage = {
    categories: [],
    name: "",
    benefits: "<ul><li>Benefit 1</li><li>Benefit 2</li></ul>",
    duration: 31536000,
    price: 0.0,
    online_payments: false,
    hidden: true,
    img: null,
  };
  $scope.hiddenOptions = [
    {
      label: "Hidden",
      value: true,
    },
    {
      label: "Visible",
      value: false,
    },
  ];
  $scope.paymentOptions = [
    {
      label: "Take payment online",
      value: true,
    },
    {
      label: "Handle payment offline",
      value: false,
    },
  ];

  // Set image upload options
  $scope.imageUploadOptions = {
    resize: false,
    resizeShape: "rectangle",
    resizeSize: {
      w: 1250,
      h: 640,
    },
    resizeAspectRatio: 1,
  };

  $scope.image = {
    data: null,
    uploaded: false,
  };

  // methods
  $scope.close = $uibModalInstance.close;
  $scope.handleBenefitsChange = handleBenefitsChange;
  $scope.saveMemberPackage = saveMemberPackage;
  $scope.deleteMemberPackage = deleteMemberPackage;
  $scope.handleImage = handleImage;
  $scope.handleImageError = handleImageError;
  $scope.getCategoryTypes = getCategoryTypes;
  $scope.getCategories = getCategories;
  $scope.setCategories = setCategories;

  $scope.currencySymbol = thisSiteSettings.currency_symbol;
  /**
   * Initialises the controller.
   *
   * @returns {Promise<void>}
   */
  async function bootstrap(): Promise<void> {
    try {
      $scope.isLoading = true;

      if (memberPackageId) {
        await getMemberPackage();
      }

      await getCategoryTypes();
      $scope.isLoading = false;
      $scope.$apply();
    } catch (error) {
      $scope.isLoading = false;
      throw error;
    }
  }
  /**
   * Retrieves category types from the API
   *
   * @returns {Promise<void>}
   */
  function getCategoryTypes(): Promise<void> {
    return new Promise((resolve, reject) => {
      CategoryTypesApi.query(
        { "categorizables[]": ["member_packages"] },
        async (response: any) => {
          $scope.categoryTypes = response;
          await getMemberPackage();
          resolve();
        },
        reject,
      );
    });
  }
  /**
   * Retrieves categories from the API
   *
   * @returns {Promise<void>}
   */
  function getCategories(): Promise<void> {
    return new Promise((resolve, reject) => {
      CategoriesApi.query((response) => {
        $scope.categories = response;
        angular.forEach($scope.categoryTypes, (categoryType) => {
          const cats = $scope.categories.filter((cat) => {
            return cat.type_id === categoryType.id;
          });

          categoryType.categories = cats;
        });
        resolve();
      }, reject);
    });
  }
  /**
   * Loads a page to be edited
   * @return {void}
   */
  function getMemberPackage() {
    $scope.isLoadingMessage = "Loading member package...";
    $scope.isLoading = true;

    MemberPackagesApi.get(
      {
        id: $scope.memberPackageId,
      },
      (response) => {
        // Add member package to scope
        Object.assign($scope.memberPackage, response.data);

        $scope.days = response.data.duration / 86400;
        $scope.isLoading = false;
      },
      (err) => {
        $scope.isLoading = false;
        handleError(err);
      },
    );
  }

  /**
   * Updates benefits content.
   *
   * @param {string} content html
   * @returns {void}
   */
  function handleBenefitsChange(content) {
    $scope.memberPackage.benefits = content;
  }

  /**
   * Attempts to create or update a member package from the provided form data
   * @return {void}
   */
  function saveMemberPackage() {
    let funcName;
    const params: Record<string, any> = {};

    if ($scope.createNewMemberPackage) {
      funcName = "save";
      params.id = $scope.memberPackageId;
    } else {
      funcName = "update";
    }

    $scope.isLoadingMessage = $scope.createNewPage
      ? "Creating new member package..."
      : "Saving member package...";
    $scope.isLoading = true;

    saveImage().then(function () {
      MemberPackagesApi[funcName](
        params,
        $scope.memberPackage,
        (response) => {
          // Wait for UI prettiness
          $timeout(() => {
            $scope.isLoading = false;

            // Close modal
            $uibModalInstance.close(response.data);
          }, 400);
        },
        (err) => {
          $scope.isLoading = false;
          $scope.formErrors = err.data;
        },
      );
    });
  }

  /**
   * Deletes this page after the user confirms
   * @return {void}
   */
  function deleteMemberPackage() {
    const handleSuccess = () => {
      $scope.forceClose = true;
      $uibModalInstance.close("deleted");
    };
    const handleCancel = () => {
      $scope.isLoading = false;
    };

    confirmDialog(
      "Are you sure you want to delete this member package?",
    ).result.then((confirm) => {
      if (confirm) {
        $scope.isLoadingMessage = "Deleting...";
        $scope.isLoading = true;

        MemberPackagesApi.delete(
          {
            id: $scope.memberPackage.id,
          },
          handleSuccess,
          handleCancel,
        );
      }
    });
  }

  /**
   * Handles the image chosen by the user
   * @param  {file} file - base64 image file
   * @return {void}
   */
  function handleImage(file) {
    $scope.image.data = file;
    $scope.image.uploaded = false;
  }

  /**
   * Shows file errors
   * @param  {object} imageError - provide as  {image: '[message]'}
   * @return {void}
   */
  function handleImageError(imageError) {
    $scope.formErrors = angular.merge($scope.formError, imageError);
  }

  /**
   * Uploads the banner image if it has been changed.
   *
   * @returns {Promise<Record<string, any>>} The updated category.
   */
  async function saveImage(): Promise<void> {
    const promise = new Promise<void>((resolve) => {
      if (!$scope.image.data || $scope.image.uploaded) {
        // No image set, or already uploaded. No need to do anything.
        return resolve();
      }

      async function handleUploadSuccess(result: {
        path: string;
        src: string;
      }): Promise<void> {
        if (result && result.path) {
          // update package image value
          $scope.memberPackage.img = result.src;

          return resolve();
        } else {
          throw new Error("Invalid response from image upload endpoint.");
        }
      }

      const handleUploadError = (err: any): void => {
        throw err;
      };

      const handleUploadProgress = (progress: number): void => {
        $scope.isLoadingProgress = progress;

        if (progress === 100) {
          $scope.isLoadingProgress = 0;
          $scope.isLoadingMessage = "Saving image...";
        }
      };

      $scope.isLoadingMessage = "Uploading image...";
      UploadsApi.uploadFile($scope.image.data, "site").then(
        handleUploadSuccess,
        handleUploadError,
        handleUploadProgress,
      );
    });

    return promise;
  } /**
   * Replaces selected categories on the resources object.
   *
   * @param {number[]} categoryIds
   * @returns {void}
   */
  function setCategories(categoryIds: number[]): void {
    $scope.memberPackages.categories = categoryIds;
    $scope.$apply();
  }

  bootstrap();

  // Catch the modal being closed for any reason
  $scope.$on("modal.closing", (event, reason, closed) => {
    if (!closed) {
      return event.preventDefault();
    }

    if ($scope.forceClose) {
      return true;
    }

    return false;
  });

  // go!
  (function init() {
    // Do we need to load a package?
    if (!$scope.createNewMemberPackage) {
      getMemberPackage();
    }
  })();
}
